const cdn_url = '/img/photo_editor_presets/';
const cdn_stickers_url = cdn_url + 'stickers/';
const cdn_marks_url = cdn_url + 'marks/';

export default {
	packs:[{
		name:"Default",
		pack:'default',
		stickers:[],
		marks:[{
			name:"Default 1",
			image:'default_01_1x1.png',
			full:cdn_marks_url + 'default/default_01_1x1.png',
			sizes:{
				square:cdn_marks_url + 'default/default_01_1x1.png',
				post:cdn_marks_url + 'default/default_01_1x1.png',
				story:cdn_marks_url + 'default/default_01_1x1.png',
			},
			pack:'default',
		}, {
			name:"Default 2",
			image:'default_02_1x1.png',
			full:cdn_marks_url + 'default/default_02_1x1.png',
			sizes:{
				square:cdn_marks_url + 'default/default_02_1x1.png',
				post:cdn_marks_url + 'default/default_02_1x1.png',
				story:cdn_marks_url + 'default/default_02_1x1.png',
			},
			pack:'default',
		}, {
			name:"Default 3",
			image:'default_03_1x1.png',
			full:cdn_marks_url + 'default/default_03_1x1.png',
			sizes:{
				square:cdn_marks_url + 'default/default_03_1x1.png',
				post:cdn_marks_url + 'default/default_03_1x1.png',
				story:cdn_marks_url + 'default/default_03_1x1.png',
			},
			pack:'default',
		}, {
			name:"Default 4",
			image:'default_04_1x1.png',
			full:cdn_marks_url + 'default/default_04_1x1.png',
			sizes:{
				square:cdn_marks_url + 'default/default_04_1x1.png',
				post:cdn_marks_url + 'default/default_04_1x1.png',
				story:cdn_marks_url + 'default/default_04_1x1.png',
			},
			pack:'default',
		}],
	}, {
		name:"Christmas",
		pack:'xmas',
		stickers:[{
			name:"Feliz Año Nuevo",
			image:'feliz_ano_nuevo.png',
			full:cdn_stickers_url + 'xmas/feliz_ano_nuevo.png',
			pack:'xmas',
		}, {
			name:"Happy New Year",
			image:'happy_new_year.png',
			full:cdn_stickers_url + 'xmas/happy_new_year.png',
			pack:'xmas',
		}, {
			name:"Feliz Navidad",
			image:'feliz_navidad.png',
			full:cdn_stickers_url + 'xmas/feliz_navidad.png',
			pack:'xmas',
		}, {
			name:"Decoration ball 1",
			image:'ball-01.png',
			full:cdn_stickers_url + 'xmas/ball-01.png',
			pack:'xmas',
		}, {
			name:"Decoration ball 2",
			image:'ball-02.png',
			full:cdn_stickers_url + 'xmas/ball-02.png',
			pack:'xmas',
		}, {
			name:"Decoration ball 3",
			image:'ball-03.png',
			full:cdn_stickers_url + 'xmas/ball-03.png',
			pack:'xmas',
		}, {
			name:"Candy stick",
			image:'candy-stick.png',
			full:cdn_stickers_url + 'xmas/candy-stick.png',
			pack:'xmas',
		}, {
			name:"Champagne",
			image:'champagne.png',
			full:cdn_stickers_url + 'xmas/champagne.png',
			pack:'xmas',
		}, {
			name:"Gingerbread Man",
			image:'gingerman.png',
			full:cdn_stickers_url + 'xmas/gingerman.png',
			pack:'xmas',
		}, {
			name:"Merry Christmas",
			image:'merry-christmas.png',
			full:cdn_stickers_url + 'xmas/merry-christmas.png',
			pack:'xmas',
		}, {
			name:"Present",
			image:'present.png',
			full:cdn_stickers_url + 'xmas/present.png',
			pack:'xmas',
		}, {
			name:"Santa's hat",
			image:'santa-hat.png',
			full:cdn_stickers_url + 'xmas/santa-hat.png',
			pack:'xmas',
		}, {
			name:"Shooting Star",
			image:'shooting-star.png',
			full:cdn_stickers_url + 'xmas/shooting-star.png',
			pack:'xmas',
		}, {
			name:"Stocking",
			image:'sock.png',
			full:cdn_stickers_url + 'xmas/sock.png',
			pack:'xmas',
		}, {
			name:"Star",
			image:'star.png',
			full:cdn_stickers_url + 'xmas/star.png',
			pack:'xmas',
		}, {
			name:"Tree",
			image:'tree.png',
			full:cdn_stickers_url + 'xmas/tree.png',
			pack:'xmas',
		}, {
			name:"Turkey",
			image:'turkey.png',
			full:cdn_stickers_url + 'xmas/turkey.png',
			pack:'xmas',
		}],
		marks:[{
			name:"Light decorations",
			image:'frame_01_1x1.png',
			full:cdn_marks_url + 'xmas/frame_01_1x1.png',
			sizes:{
				square:cdn_marks_url + 'xmas/frame_01_1x1.png',
				post:cdn_marks_url + 'xmas/frame_01_120x63.png',
				story:cdn_marks_url + 'xmas/frame_01_375x667.png',
			},
			pack:'xmas',
		}, {
			name:"Traditional frame",
			image:'frame_02_1x1.png',
			full:cdn_marks_url + 'xmas/frame_02_1x1.png',
			sizes:{
				square:cdn_marks_url + 'xmas/frame_02_1x1.png',
				post:cdn_marks_url + 'xmas/frame_02_120x63.png',
				story:cdn_marks_url + 'xmas/frame_02_375x667.png',
			},
			pack:'xmas',
		}, {
			name:"Mistletoe",
			image:'frame_03_1x1.png',
			full:cdn_marks_url + 'xmas/frame_03_1x1.png',
			sizes:{
				square:cdn_marks_url + 'xmas/frame_03_1x1.png',
				post:cdn_marks_url + 'xmas/frame_03_120x63.png',
				story:cdn_marks_url + 'xmas/frame_03_375x667.png',
			},
			pack:'xmas',
		}, {
			name:"Ho ho ho",
			image:'frame_04_1x1.png',
			full:cdn_marks_url + 'xmas/frame_04_1x1.png',
			sizes:{
				square:cdn_marks_url + 'xmas/frame_04_1x1.png',
				post:cdn_marks_url + 'xmas/frame_04_1x1.png',
				story:cdn_marks_url + 'xmas/frame_04_1x1.png',
			},
			pack:'xmas',
		}, {
			name:"Elf",
			image:'frame_05_1x1.png',
			full:cdn_marks_url + 'xmas/frame_05_1x1.png',
			sizes:{
				square:cdn_marks_url + 'xmas/frame_05_1x1.png',
				post:cdn_marks_url + 'xmas/frame_05_1x1.png',
				story:cdn_marks_url + 'xmas/frame_05_1x1.png',
			},
			pack:'xmas',
		}, {
			name:"Santa",
			image:'frame_06_1x1.png',
			full:cdn_marks_url + 'xmas/frame_06_1x1.png',
			sizes:{
				square:cdn_marks_url + 'xmas/frame_06_1x1.png',
				post:cdn_marks_url + 'xmas/frame_06_1x1.png',
				story:cdn_marks_url + 'xmas/frame_06_1x1.png',
			},
			pack:'xmas',
		}],
	}, {
		name:"Reactions",
		pack:'reactions',
		stickers:[{
			name:"Angry",
			image:'angry.png',
			full:cdn_stickers_url + 'reactions/angry.png',
			pack:'reactions',
		}, {
			name:"Crazy",
			image:'crazy.png',
			full:cdn_stickers_url + 'reactions/crazy.png',
			pack:'reactions',
		}, {
			name:"Dead",
			image:'dead.png',
			full:cdn_stickers_url + 'reactions/dead.png',
			pack:'reactions',
		}, {
			name:"Eating",
			image:'eating.png',
			full:cdn_stickers_url + 'reactions/eating.png',
			pack:'reactions',
		}, {
			name:"Happy",
			image:'happy.png',
			full:cdn_stickers_url + 'reactions/happy.png',
			pack:'reactions',
		}, {
			name:"Pervert",
			image:'pervert.png',
			full:cdn_stickers_url + 'reactions/pervert.png',
			pack:'reactions',
		}, {
			name:"Sad",
			image:'sad.png',
			full:cdn_stickers_url + 'reactions/sad.png',
			pack:'reactions',
		}, {
			name:"Sir",
			image:'sir.png',
			full:cdn_stickers_url + 'reactions/sir.png',
			pack:'reactions',
		}, {
			name:"Sleepy",
			image:'sleepy.png',
			full:cdn_stickers_url + 'reactions/sleepy.png',
			pack:'reactions',
		}, {
			name:"Wow",
			image:'wow.png',
			full:cdn_stickers_url + 'reactions/wow.png',
			pack:'reactions',
		}],
		marks:[
		],
	}, {
		name:"Father's day",
		pack:'father',
		stickers:[{
			name:"Glasses",
			image:'glasses.png',
			full:cdn_stickers_url + 'father/glasses.png',
			pack:'father',
		}, {
			name:"Love you Dad",
			image:'loveyoudad.png',
			full:cdn_stickers_url + 'father/loveyoudad.png',
			pack:'father',
		}, {
			name:"Moustache",
			image:'moustache.png',
			full:cdn_stickers_url + 'father/moustache.png',
			pack:'father',
		}, {
			name:"Te quiero papá",
			image:'tequieropapa.png',
			full:cdn_stickers_url + 'father/tequieropapa.png',
			pack:'father',
		}, {
			name:"Tie",
			image:'tie.png',
			full:cdn_stickers_url + 'father/tie.png',
			pack:'father',
		}],
		marks:[{
			name:"Father 1",
			image:'father_1.png',
			full:cdn_marks_url + 'father/father_1.png',
			sizes:{
				square:cdn_marks_url + 'father/father_1.png',
				post:cdn_marks_url + 'fatherfather_1.png',
				story:cdn_marks_url + 'father/father_1.png',
			},
			pack:'father',
		}, {
			name:"Father 2",
			image:'father_2.png',
			full:cdn_marks_url + 'father/father_2.png',
			sizes:{
				square:cdn_marks_url + 'father/father_2.png',
				post:cdn_marks_url + 'fatherfather_2.png',
				story:cdn_marks_url + 'father/father_2.png',
			},
			pack:'father',
		}, {
			name:"Father 3",
			image:'father_3.png',
			full:cdn_marks_url + 'father/father_3.png',
			sizes:{
				square:cdn_marks_url + 'father/father_3.png',
				post:cdn_marks_url + 'fatherfather_3.png',
				story:cdn_marks_url + 'father/father_3.png',
			},
			pack:'father',
		}],
	}, {
		name:"Mother",
		pack:'mother',
		stickers:[{
			name:"Birds",
			image:'birds_mothersday.png',
			full:cdn_stickers_url + 'mother/birds_mothersday.png',
			pack:'mother',
		}, {
			name:"Love you Mom",
			image:'love_you_mom.png',
			full:cdn_stickers_url + 'mother/love_you_mom.png',
			pack:'mother',
		}, {
			name:"Mama",
			image:'mama.png',
			full:cdn_stickers_url + 'mother/mama.png',
			pack:'mother',
		}, {
			name:"Mom",
			image:'mom.png',
			full:cdn_stickers_url + 'mother/mom.png',
			pack:'mother',
		}, {
			name:"Te quiero mama",
			image:'te_quiero_mama.png',
			full:cdn_stickers_url + 'mother/te_quiero_mama.png',
			pack:'mother',
		}],
		marks:[{
			name:"Mother 1",
			image:'mother1.png',
			full:cdn_marks_url + 'mother/mother1.png',
			sizes:{
				square:cdn_marks_url + 'mother/mother1.png',
				post:cdn_marks_url + 'mother/mother1.png',
				story:cdn_marks_url + 'mother/mother1.png',
			},
			pack:'mother',
		}, {
			name:"Mother 2",
			image:'mother2.png',
			full:cdn_marks_url + 'mother/mother2.png',
			sizes:{
				square:cdn_marks_url + 'mother/mother2.png',
				post:cdn_marks_url + 'mother/mother2.png',
				story:cdn_marks_url + 'mother/mother2.png',
			},
			pack:'mother',
		}, {
			name:"Mother 3",
			image:'mother3.png',
			full:cdn_marks_url + 'mother/mother3.png',
			sizes:{
				square:cdn_marks_url + 'mother/mother3.png',
				post:cdn_marks_url + 'mother/mother3.png',
				story:cdn_marks_url + 'mother/mother3.png',
			},
			pack:'mother',
		}],
	}, {
		name:"Halloween",
		pack:'halloween',
		stickers:[{
			name:"Candy",
			image:'candy.png',
			full:cdn_stickers_url + 'halloween/candy.png',
			pack:'halloween',
		}, {
			name:"Frankenstein",
			image:'frankenstein.png',
			full:cdn_stickers_url + 'halloween/frankenstein.png',
			pack:'halloween',
		}, {
			name:"Ghost",
			image:'ghost.png',
			full:cdn_stickers_url + 'halloween/ghost.png',
			pack:'halloween',
		}, {
			name:"Pumpkin",
			image:'pumpkin.png',
			full:cdn_stickers_url + 'halloween/pumpkin.png',
			pack:'halloween',
		}, {
			name:"Skul",
			image:'skull.png',
			full:cdn_stickers_url + 'halloween/skull.png',
			pack:'halloween',
		}, {
			name:"Trick or Treat",
			image:'trick_or_treat.png',
			full:cdn_stickers_url + 'halloween/trick_or_treat.png',
			pack:'halloween',
		}, {
			name:"Truco o Trato",
			image:'truco_o_trato.png',
			full:cdn_stickers_url + 'halloween/truco_o_trato.png',
			pack:'halloween',
		}, {
			name:"Witch",
			image:'witch.png',
			full:cdn_stickers_url + 'halloween/witch.png',
			pack:'halloween',
		}],
		marks:[{
			name:"Halloween 1",
			image:'frame_1_halloween.png',
			full:cdn_marks_url + 'halloween/frame_1_halloween.png',
			sizes:{
				square:cdn_marks_url + 'halloween/frame_1_halloween.png',
				post:cdn_marks_url + 'halloween/frame_1_halloween.png',
				story:cdn_marks_url + 'halloween/frame_1_halloween.png',
			},
			pack:'halloween',
		}, {
			name:"Halloween 2",
			image:'frame_2_halloween.png',
			full:cdn_marks_url + 'halloween/frame_2_halloween.png',
			sizes:{
				square:cdn_marks_url + 'halloween/frame_2_halloween.png',
				post:cdn_marks_url + 'halloween/frame_2_halloween.png',
				story:cdn_marks_url + 'halloween/frame_2_halloween.png',
			},
			pack:'halloween',
		}, {
			name:"Halloween 3",
			image:'frame_3_halloween.png',
			full:cdn_marks_url + 'halloween/frame_3_halloween.png',
			sizes:{
				square:cdn_marks_url + 'halloween/frame_3_halloween.png',
				post:cdn_marks_url + 'halloween/frame_3_halloween.png',
				story:cdn_marks_url + 'halloween/frame_3_halloween.png',
			},
			pack:'halloween',
		}],
	}, {
		name:"Day of the Dead",
		pack:'diamuertos',
		stickers:[{
			name:"Calavera 1",
			image:'calavera_1.png',
			full:cdn_stickers_url + 'diamuertos/calavera_1.png',
			pack:'diamuertos',
		}, {
			name:"Calavera 2",
			image:'calavera_2.png',
			full:cdn_stickers_url + 'diamuertos/calavera_2.png',
			pack:'diamuertos',
		}, {
			name:"Calavera 3",
			image:'calavera_3.png',
			full:cdn_stickers_url + 'diamuertos/calavera_3.png',
			pack:'diamuertos',
		}, {
			name:"Cruz",
			image:'cruz.png',
			full:cdn_stickers_url + 'diamuertos/cruz.png',
			pack:'diamuertos',
		}, {
			name:"Dia de Muertos",
			image:'dia_de_muertos.png',
			full:cdn_stickers_url + 'diamuertos/dia_de_muertos.png',
			pack:'diamuertos',
		}, {
			name:"Flor 1",
			image:'flor_1.png',
			full:cdn_stickers_url + 'diamuertos/flor_1.png',
			pack:'diamuertos',
		}, {
			name:"Flor 2",
			image:'flor_2.png',
			full:cdn_stickers_url + 'diamuertos/flor_2.png',
			pack:'diamuertos',
		}, {
			name:"Flor 3",
			image:'flor_3.png',
			full:cdn_stickers_url + 'diamuertos/flor_3.png',
			pack:'diamuertos',
		}, {
			name:"Tumba",
			image:'tumba.png',
			full:cdn_stickers_url + 'diamuertos/tumba.png',
			pack:'diamuertos',
		}, {
			name:"Vela",
			image:'vela.png',
			full:cdn_stickers_url + 'diamuertos/vela.png',
			pack:'diamuertos',
		}],
		marks:[{
			name:"Dia Muertos 1",
			image:'marco_1_dia_de_muertos.png',
			full:cdn_marks_url + 'diamuertos/marco_1_dia_de_muertos.png',
			sizes:{
				square:cdn_marks_url + 'diamuertos/marco_1_dia_de_muertos.png',
				post:cdn_marks_url + 'diamuertos/marco_1_dia_de_muertos.png',
				story:cdn_marks_url + 'diamuertos/marco_1_dia_de_muertos.png',
			},
			pack:'diamuertos',
		}, {
			name:"Dia Muertos 2",
			image:'marco_2_dia_de_muertos.png',
			full:cdn_marks_url + 'diamuertos/marco_2_dia_de_muertos.png',
			sizes:{
				square:cdn_marks_url + 'diamuertos/marco_2_dia_de_muertos.png',
				post:cdn_marks_url + 'diamuertos/marco_2_dia_de_muertos.png',
				story:cdn_marks_url + 'diamuertos/marco_2_dia_de_muertos.png',
			},
			pack:'diamuertos',
		}, {
			name:"Dia Muertos 3",
			image:'marco_3_dia_de_muertos.png',
			full:cdn_marks_url + 'diamuertos/marco_3_dia_de_muertos.png',
			sizes:{
				square:cdn_marks_url + 'diamuertos/marco_3_dia_de_muertos.png',
				post:cdn_marks_url + 'diamuertos/marco_3_dia_de_muertos.png',
				story:cdn_marks_url + 'diamuertos/marco_3_dia_de_muertos.png',
			},
			pack:'diamuertos',
		}],
	}, {
		name:"Valentine",
		pack:'valentine',
		stickers:[{
			name:"Birds",
			image:'birds.png',
			full:cdn_stickers_url + 'valentine/birds.png',
			pack:'valentine',
		}, {
			name:"Arrow",
			image:'flecha_cupido.png',
			full:cdn_stickers_url + 'valentine/flecha_cupido.png',
			pack:'valentine',
		}, {
			name:"Love you",
			image:'iloveyou.png',
			full:cdn_stickers_url + 'valentine/Iloveyou.png',
			pack:'valentine',
		}, {
			name:"Te quiero",
			image:'tequiero.png',
			full:cdn_stickers_url + 'valentine/tequiero.png',
			pack:'valentine',
		}],
		marks:[{
			name:"Valentine 1",
			image:'valentine_01_1x1.png',
			full:cdn_marks_url + 'valentine/valentine_01_1x1.png',
			sizes:{
				square:cdn_marks_url + 'valentine/valentine_01_1x1.png',
				post:cdn_marks_url + 'valentine/valentine_01_1x1.png',
				story:cdn_marks_url + 'valentine/valentine_01_1x1.png',
			},
			pack:'valentine',
		}, {
			name:"Valentine 2",
			image:'valentine_02_1x1.png',
			full:cdn_marks_url + 'valentine/valentine_02_1x1.png',
			sizes:{
				square:cdn_marks_url + 'valentine/valentine_02_1x1.png',
				post:cdn_marks_url + 'valentine/valentine_02_1x1.png',
				story:cdn_marks_url + 'valentine/valentine_02_1x1.png',
			},
			pack:'valentine',
		}, {
			name:"Valentine 3",
			image:'valentine_03_1x1.png',
			full:cdn_marks_url + 'valentine/valentine_03_1x1.png',
			sizes:{
				square:cdn_marks_url + 'valentine/valentine_03_1x1.png',
				post:cdn_marks_url + 'valentine/valentine_03_1x1.png',
				story:cdn_marks_url + 'valentine/valentine_03_1x1.png',
			},
			pack:'valentine',
		}],
	}, {
		name:"Party",
		pack:'party',
		stickers:[{
			name:"Balloon (blue)",
			image:'balloon-blue.png',
			full:cdn_stickers_url + 'party/balloon-blue.png',
			pack:'party',
		}, {
			name:"Bow tie",
			image:'bow-tie.png',
			full:cdn_stickers_url + 'party/bow-tie.png',
			pack:'party',
		}, {
			name:"Hat",
			image:'hat.png',
			full:cdn_stickers_url + 'party/hat.png',
			pack:'party',
		}, {
			name:"Mask (pink)",
			image:'mask-pink.png',
			full:cdn_stickers_url + 'party/mask-pink.png',
			pack:'party',
		}, {
			name:"Sir hat",
			image:'sir-hat.png',
			full:cdn_stickers_url + 'party/sir-hat.png',
			pack:'party',
		}, {
			name:"Sunglasses (green)",
			image:'sunglasses-green.png',
			full:cdn_stickers_url + 'party/sunglasses-green.png',
			pack:'party',
		}, {
			name:"Mimo",
			image:'mimo.png',
			full:cdn_stickers_url + 'carnival2/mimo.png',
			pack:'party',
		}, {
			name:"Peluca",
			image:'peluca.png',
			full:cdn_stickers_url + 'carnival2/peluca.png',
			pack:'party',
		}],
		marks:[],
	}, {
		name:"Arrows",
		pack:'arrows',
		stickers:[{
			name:"Bottom-left 01 (blue)",
			image:'bottom-left-01-blue.png',
			full:cdn_stickers_url + 'arrows/bottom-left-01-blue.png',
			pack:'arrows',
		}, {
			name:"Bottom-left 02 (yellow)",
			image:'bottom-left-02-yellow.png',
			full:cdn_stickers_url + 'arrows/bottom-left-02-yellow.png',
			pack:'arrows',
		}, {
			name:"Bottom-left 03 (black)",
			image:'bottom-left-03-black.png',
			full:cdn_stickers_url + 'arrows/bottom-left-03-black.png',
			pack:'arrows',
		}, {
			name:"Bottom-right 01 (black)",
			image:'bottom-right-01-black.png',
			full:cdn_stickers_url + 'arrows/bottom-right-01-black.png',
			pack:'arrows',
		}, {
			name:"Bottom-right 02 (black)",
			image:'bottom-right-02-black.png',
			full:cdn_stickers_url + 'arrows/bottom-right-02-black.png',
			pack:'arrows',
		}, {
			name:"Top-left 01 (red)",
			image:'top-left-01-red.png',
			full:cdn_stickers_url + 'arrows/top-left-01-red.png',
			pack:'arrows',
		}, {
			name:"Top-right 01 (green)",
			image:'top-right-01-green.png',
			full:cdn_stickers_url + 'arrows/top-right-01-green.png',
			pack:'arrows',
		}],
		marks:[
		],
	}, {
		name:"Expressions",
		pack:'expressions',
		stickers:[{
			name:"BANG!",
			image:'bang.png',
			full:cdn_stickers_url + 'expressions/bang.png',
			pack:'expressions',
		}, {
			name:"EASY!",
			image:'easy.png',
			full:cdn_stickers_url + 'expressions/easy.png',
			pack:'expressions',
		}, {
			name:"MMMM!",
			image:'mmmm.png',
			full:cdn_stickers_url + 'expressions/mmmm.png',
			pack:'expressions',
		}, {
			name:"OHHH!",
			image:'ohhh.png',
			full:cdn_stickers_url + 'expressions/ohhh.png',
			pack:'expressions',
		}, {
			name:"OK!",
			image:'ok.png',
			full:cdn_stickers_url + 'expressions/ok.png',
			pack:'expressions',
		}, {
			name:"OMG!",
			image:'omg.png',
			full:cdn_stickers_url + 'expressions/omg.png',
			pack:'expressions',
		}, {
			name:"POW!",
			image:'pow.png',
			full:cdn_stickers_url + 'expressions/pow.png',
			pack:'expressions',
		}, {
			name:"WOW!",
			image:'wow.png',
			full:cdn_stickers_url + 'expressions/wow.png',
			pack:'expressions',
		}, {
			name:"WTF!",
			image:'wtf.png',
			full:cdn_stickers_url + 'expressions/wtf.png',
			pack:'expressions',
		}],
		marks:[],
	}, {
		name:"Spring",
		pack:'spring',
		stickers:[{
			name:"Bee",
			image:'bee.png',
			full:cdn_stickers_url + 'spring/bee.png',
			pack:'spring',
		}, {
			name:"Bird",
			image:'bird.png',
			full:cdn_stickers_url + 'spring/bird.png',
			pack:'spring',
		}, {
			name:"Butterfly",
			image:'butterfly.png',
			full:cdn_stickers_url + 'spring/butterfly.png',
			pack:'spring',
		}],
		marks:[{
			name:"Spring 1",
			image:'spring-1.png',
			full:cdn_marks_url + 'spring/frame1_spring.png',
			sizes:{
				square:cdn_marks_url + 'spring/frame1_spring.png',
				post:cdn_marks_url + 'spring/frame1_spring.png',
				story:cdn_marks_url + 'spring/frame1_spring.png',
			},
			pack:'spring',
		}, {
			name:"Spring 2",
			image:'spring-2.png',
			full:cdn_marks_url + 'spring/frame2_spring.png',
			sizes:{
				square:cdn_marks_url + 'spring/frame2_spring.png',
				post:cdn_marks_url + 'spring/frame2_spring.png',
				story:cdn_marks_url + 'spring/frame2_spring.png',
			},
			pack:'spring',
		}, {
			name:"Spring 3",
			image:'spring-3.png',
			full:cdn_marks_url + 'spring/frame3_spring.png',
			sizes:{
				square:cdn_marks_url + 'spring/frame3_spring.png',
				post:cdn_marks_url + 'spring/frame3_spring.png',
				story:cdn_marks_url + 'spring/frame3_spring.png',
			},
			pack:'spring',
		}],
	}, {
		name:"Love",
		pack:'love',
		stickers:[{
			name:"Big Kiss",
			image:'big-kiss.png',
			full:cdn_stickers_url + 'love/big-kiss.png',
			pack:'love',
		}, {
			name:"Diamond",
			image:'diamond.png',
			full:cdn_stickers_url + 'love/diamond.png',
			pack:'love',
		}, {
			name:"Heart",
			image:'heart.png',
			full:cdn_stickers_url + 'love/heart.png',
			pack:'love',
		}, {
			name:"Rose",
			image:'rose.png',
			full:cdn_stickers_url + 'love/rose.png',
			pack:'love',
		}],
		marks:[],
	}, {
		name:"Football",
		pack:'america_cup',
		stickers:[{
			name:"Ball",
			image:'balon.png',
			full:cdn_stickers_url + 'cupamerica/balon.png',
			pack:'america_cup',
		}, {
			name:"Boot",
			image:'bota.png',
			full:cdn_stickers_url + 'cupamerica/bota.png',
			pack:'america_cup',
		}, {
			name:"Goal",
			image:'gol.png',
			full:cdn_stickers_url + 'cupamerica/gol.png',
			pack:'america_cup',
		}, {
			name:"Yellow Card",
			image:'tarjeta_amarilla.png',
			full:cdn_stickers_url + 'cupamerica/tarjeta_amarilla.png',
			pack:'america_cup',
		}, {
			name:"Red Card",
			image:'tarjeta_roja.png',
			full:cdn_stickers_url + 'cupamerica/tarjeta_roja.png',
			pack:'america_cup',
		}, {
			name:"Let's Go",
			image:'vamos.png',
			full:cdn_stickers_url + 'cupamerica/vamos.png',
			pack:'america_cup',
		}],
		marks:[],
	}, {
		name:"Back to School",
		pack:'back_school',
		stickers:[{
			name:"Bata A",
			image:'bata-a.png',
			full:cdn_stickers_url + 'school/bata-a.png',
			pack:'back_school',
		}, {
			name:"Bata B",
			image:'bata-b.png',
			full:cdn_stickers_url + 'school/bata-b.png',
			pack:'back_school',
		}, {
			name:"Calculadora",
			image:'calculadora.png',
			full:cdn_stickers_url + 'school/calculadora.png',
			pack:'back_school',
		}, {
			name:"Colores",
			image:'colores.png',
			full:cdn_stickers_url + 'school/colores.png',
			pack:'back_school',
		}, {
			name:"Estuche",
			image:'estuche.png',
			full:cdn_stickers_url + 'school/estuche.png',
			pack:'back_school',
		}, {
			name:"Libreta",
			image:'libreta.png',
			full:cdn_stickers_url + 'school/libreta.png',
			pack:'back_school',
		}, {
			name:"Libros",
			image:'libros.png',
			full:cdn_stickers_url + 'school/libros.png',
			pack:'back_school',
		}, {
			name:"Lupa",
			image:'lupa.png',
			full:cdn_stickers_url + 'school/lupa.png',
			pack:'back_school',
		}, {
			name:"Pintura",
			image:'pintura.png',
			full:cdn_stickers_url + 'school/pintura.png',
			pack:'back_school',
		}, {
			name:"Regla",
			image:'regla.png',
			full:cdn_stickers_url + 'school/regla.png',
			pack:'back_school',
		}],
		marks:[{
			name:"Back to School 1",
			image:'school_01_1x1.png',
			full:cdn_marks_url + 'school/school_01_1x1.png',
			sizes:{
				square:cdn_marks_url + 'school/school_01_1x1.png',
				post:cdn_marks_url + 'school/school_01_1x1.png',
				story:cdn_marks_url + 'school/school_01_1x1.png',
			},
			pack:'back_school',
		}, {
			name:"Back to School 2",
			image:'school_02_1x1.png',
			full:cdn_marks_url + 'school/school_02_1x1.png',
			sizes:{
				square:cdn_marks_url + 'school/school_02_1x1.png',
				post:cdn_marks_url + 'school/school_02_1x1.png',
				story:cdn_marks_url + 'school/school_02_1x1.png',
			},
			pack:'back_school',
		}, {
			name:"Back to School 3",
			image:'school_03_1x1.png',
			full:cdn_marks_url + 'school/school_03_1x1.png',
			sizes:{
				square:cdn_marks_url + 'school/school_03_1x1.png',
				post:cdn_marks_url + 'school/school_03_1x1.png',
				story:cdn_marks_url + 'school/school_03_1x1.png',
			},
			pack:'back_school',
		}],
	}, {
		name:"St.Patrick's Day",
		pack:'patricks',
		stickers:[{
			name:"Beer",
			image:'beer.png',
			full:cdn_stickers_url + 'patricks/beer.png',
			pack:'patricks',
		}, {
			name:"Bowtie",
			image:'bowtie.png',
			full:cdn_stickers_url + 'patricks/bowtie.png',
			pack:'patricks',
		}, {
			name:"Clover",
			image:'clover.png',
			full:cdn_stickers_url + 'patricks/clover.png',
			pack:'patricks',
		}, {
			name:"Coin",
			image:'coin.png',
			full:cdn_stickers_url + 'patricks/coin.png',
			pack:'patricks',
		}, {
			name:"Hat",
			image:'hat.png',
			full:cdn_stickers_url + 'patricks/hat.png',
			pack:'patricks',
		}, {
			name:"Horse Shoe",
			image:'horseshoe.png',
			full:cdn_stickers_url + 'patricks/horseshoe.png',
			pack:'patricks',
		}, {
			name:"Ireland",
			image:'ireland.png',
			full:cdn_stickers_url + 'patricks/ireland.png',
			pack:'patricks',
		}, {
			name:"Leprechaun",
			image:'leprechaun.png',
			full:cdn_stickers_url + 'patricks/leprechaun.png',
			pack:'patricks',
		}, {
			name:"Moustache",
			image:'moustache.png',
			full:cdn_stickers_url + 'patricks/moustache.png',
			pack:'patricks',
		}, {
			name:"pot",
			image:'pot.png',
			full:cdn_stickers_url + 'patricks/pot.png',
			pack:'patricks',
		}],
		marks:[{
			name:"Frame 1",
			image:'frame1-stpatricksday.png',
			full:cdn_marks_url + 'patricks/frame1-stpatricksday.png',
			sizes:{
				square:cdn_marks_url + 'patricks/frame1-stpatricksday.png',
				post:cdn_marks_url + 'patricks/frame1-stpatricksday.png',
				story:cdn_marks_url + 'patricks/frame1-stpatricksday.png',
			},
			pack:'patricks',
		}, {
			name:"Frame 2",
			image:'frame2-stpatricksday.png',
			full:cdn_marks_url + 'patricks/frame2-stpatricksday.png',
			sizes:{
				square:cdn_marks_url + 'patricks/frame2-stpatricksday.png',
				post:cdn_marks_url + 'patricks/frame2-stpatricksday.png',
				story:cdn_marks_url + 'patricks/frame2-stpatricksday.png',
			},
			pack:'patricks',
		}, {
			name:"Frame 3",
			image:'frame3-stpatricksday.png',
			full:cdn_marks_url + 'patricks/frame3-stpatricksday.png',
			sizes:{
				square:cdn_marks_url + 'patricks/frame3-stpatricksday.png',
				post:cdn_marks_url + 'patricks/frame3-stpatricksday.png',
				story:cdn_marks_url + 'patricks/frame3-stpatricksday.png',
			},
			pack:'patricks',
		}, {
			name:"Marco 1",
			image:'marco1-stpatricksday.png',
			full:cdn_marks_url + 'patricks/marco1-stpatricksday.png',
			sizes:{
				square:cdn_marks_url + 'patricks/marco1-stpatricksday.png',
				post:cdn_marks_url + 'patricks/marco1-stpatricksday.png',
				story:cdn_marks_url + 'patricks/marco1-stpatricksday.png',
			},
			pack:'patricks',
		}, {
			name:"Marco 2",
			image:'marco2-stpatricksday.png',
			full:cdn_marks_url + 'patricks/marco2-stpatricksday.png',
			sizes:{
				square:cdn_marks_url + 'patricks/marco2-stpatricksday.png',
				post:cdn_marks_url + 'patricks/marco2-stpatricksday.png',
				story:cdn_marks_url + 'patricks/marco2-stpatricksday.png',
			},
			pack:'patricks',
		}, {
			name:"Marco 3",
			image:'marco3-stpatricksday.png',
			full:cdn_marks_url + 'patricks/marco3-stpatricksday.png',
			sizes:{
				square:cdn_marks_url + 'patricks/marco3-stpatricksday.png',
				post:cdn_marks_url + 'patricks/marco3-stpatricksday.png',
				story:cdn_marks_url + 'patricks/marco3-stpatricksday.png',
			},
			pack:'patricks',
		}],
	}],
}